<section class="col">
  <!-- Search filters — always visible -->
  <p-panel header="Filter">
    <p-card data-variant="fields">
      <div class="form-box">
        <label>{{ 'Asset_Depreciation_Year' | translateWF: 'Year' }}</label>
        <p-dropdown
          [formControl]="year"
          [options]="yearOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'Asset_Depreciation_Year' | translateWF: 'Year'"
          styleClass="w-full"
        />
      </div>
      <div class="form-box">
        <label>{{ 'Asset_Depreciation_Month' | translateWF: 'Month' }}</label>
        <p-dropdown
          [formControl]="month"
          [options]="monthOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'Asset_Depreciation_Month' | translateWF: 'Month'"
          styleClass="w-full"
        />
      </div>
      <div class="form-box">
        <label>{{ 'Asset_Depreciation_Asset_Id' | translateWF: 'Asset ID' }}</label>
        <input pInputText type="text" [formControl]="assetId" [placeholder]="'Asset_Depreciation_Asset_Id' | translateWF: 'Asset ID'" class="w-full" />
      </div>
    </p-card>
  </p-panel>

  <p-panel header="Results">
    <ng-template pTemplate="icons">
      <p-button [label]="'Refresh' | translateWF: 'Refresh'" icon="pi pi-refresh" severity="secondary" [outlined]="true" [disabled]="isLoading()" (click)="loadRows()" />
      @if (!showUploadUi()) {
        <p-button [label]="'Add Excel' | translateWF: 'Add Excel'" icon="pi pi-plus" (click)="openUploadUi()" />
      }
    </ng-template>

    <p-card data-variant="compact">
      @if (!showUploadUi()) {
        <p-table [value]="rows()" [loading]="isLoading()">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'Asset_Depreciation_Asset_Id' | translateWF: 'Asset ID' }}</th>
              <th>{{ 'Asset_Depreciation_Year' | translateWF: 'Year' }}</th>
              <th>{{ 'Asset_Depreciation_Month' | translateWF: 'Month' }}</th>
              <th>{{ 'Asset_Depreciation_Amount' | translateWF: 'Depreciation Amount' }}</th>
              <th>{{ 'Asset_Depreciation_Active' | translateWF: 'Active' }}</th>
              <th>{{ 'Asset_Depreciation_Created_By' | translateWF: 'Created By' }}</th>
              <th>{{ 'Asset_Depreciation_Created_Date' | translateWF: 'Created Date' }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.assetId }}</td>
              <td>{{ row.year }}</td>
              <td>{{ monthOptions[row.month - 1].label }}</td>
              <td>{{ row.depreciationAmount | number: '1.2-2' }}</td>
              <td>
                <i
                  class="pi"
                  [class.pi-check-circle]="row.isActive"
                  [class.pi-times-circle]="!row.isActive"
                  [class.text-green-500]="row.isActive"
                  [class.text-red-400]="!row.isActive"
                ></i>
              </td>
              <td>{{ row.createdBy ?? '------' }}</td>
              <td>{{ row.createdDate ? (row.createdDate | date: 'dd/MM/yyyy HH:mm') : '------' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="text-center text-gray-400 py-6">
                {{ 'Asset_Depreciation_No_Data' | translateWF: 'No records found for the selected period' }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      } @else {
        <div class="drop__wrapper" [class.disabled]="!canUpload()" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
          @if (selectedFile) {
            <div class="drop__file">
              <i class="pi pi-file-excel text-2xl mr-2"></i>
              <span class="drop__file_name">{{ selectedFile.name }}</span>
              <p-button icon="pi pi-times" severity="secondary" [rounded]="true" [text]="true" (click)="clearFile()" [pTooltip]="'Cancel' | translateWF: 'Cancel'" />
            </div>
          } @else {
            <div class="drop__select">
              <i class="pi pi-cloud-upload text-3xl mb-2"></i>
              <p class="mb-2">{{ 'Asset_Depreciation_Drag_Drop' | translateWF: 'Drag & Drop your Excel file here or' }}</p>
              <label for="asset-depreciation-file-input" class="drop__select_label">
                <i class="pi pi-folder-open mr-2"></i>
                {{ 'Asset_Depreciation_Select_File' | translateWF: 'Select File' }}
              </label>
              <input id="asset-depreciation-file-input" type="file" accept=".xlsx" class="hidden" (change)="onFileChange($event)" />
            </div>
          }
        </div>

        <div class="row-between-center mt-4">
          <a href="assets/asset-depreciation-template.xlsx" download class="download__link">
            <i class="pi pi-download mr-2"></i>
            {{ 'Asset_Depreciation_Download_Template' | translateWF: 'Download Sample Template' }}
          </a>

          <div class="row-sm-start-center">
            <p-button [label]="'Cancel' | translateWF: 'Cancel'" severity="secondary" [outlined]="true" [disabled]="isLoading()" (click)="cancelUploadUi()" />
            <p-button [label]="'Asset_Depreciation_Import' | translateWF: 'Import'" icon="pi pi-upload" [disabled]="!canImport() || isLoading()" (click)="import()" />
          </div>
        </div>
      }
    </p-card>
  </p-panel>
</section>
